import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from 'common/StyledButton';
import Icon from 'SF/MaterialIcon';
import css from './Header.css';

const Header = props => {
  return (
    <header className={css['header']}>
      <img src="../images/starfish/starfish_icon_white.png" aria-hidden="true" className={css['image']} />
      <StyledButton 
        className={css['close-button']} 
        onClick={props.closeModal}
        aria-label="Close modal"
        asLink>
        <Icon icon='close' />
      </StyledButton>
    </header>
  );
};

Header.propTypes = {
  closeModal: PropTypes.func.isRequired,
};


export default Header;
